
import { IConfig } from '@shared/interface/config.interface'
import { dbData } from './init.db.data'

// ********************************************************
// Table 'config'
// ********************************************************
export const dbSetConfig = (providedConfig?: IConfig): Promise<number> => {
  if (providedConfig) {
    return dbData.transaction('rw', dbData.config, async () => {
      await dbData.config.clear()

      return dbData.config.put({
        uploader: providedConfig.uploader,
        security: providedConfig.security
      })
    })
  } else {
    return Promise.resolve(0)
  }
}

export const dbGetConfig = (): Promise<IConfig | undefined> => {
  return dbData.transaction('r', dbData.config, async () => {
    const configs = await dbData.config.toArray()
    return configs.length > 0 ? configs[0] : undefined
  })
}
